import { FC, useContext, useEffect } from 'react';
import { useQuery } from '@apollo/client';
import { AccuWeatherDataProps, forecastType } from '../AccuWeather.types';
import { AccuWeatherMockUXL } from '../__mock__/AccuWeatherMock';
import { PageParamsContext } from '../../../modules/context/PageContext';
import { accuWeather } from '../../../modules/graphql/index';
import { accuWeatherStore, useAccuWeatherStore } from '../../../modules/store/accuWeatherStore';

export const AccuWeatherData: FC<AccuWeatherDataProps> = ({ isAuthorMode = false, setData }) => {
  const isServer = !(typeof window != 'undefined' && window.document);
  const { preProcessorResponse, sessionID, requestId, lang } = useContext(PageParamsContext);
  const setAccuWeatherData = useAccuWeatherStore((state: accuWeatherStore) => state.setAccuWeatherData);

  let { data, loading, error } = useQuery(accuWeather, {
    fetchPolicy: isServer ? 'network-only' : 'cache-first',
    variables: {
      propertyId: preProcessorResponse?.marsha ?? '',
    },
    context: {
      headers: {
        //Update the variables of AriesReservation for ppv5
        'accept-language': lang ?? 'en-US',
        'x-b3-traceId': sessionID ?? 'fallback-token',
        'x-b3-spanId': requestId !== '' ? requestId : `${Date.now()}`,
        'correlation-id': sessionID ?? 'fallback-token',
      },
    },
    skip: isAuthorMode,
  });

  if (isAuthorMode) {
    loading = false;
    data = AccuWeatherMockUXL;
    error = undefined;
  }

  useEffect(() => {
    if (!loading) {
      if (data && Object.keys(data)) {
        setAccuWeatherData({ ...data }, loading, error, {});
        setData({ ...data });
      }
    }
  }, [data, loading, error, setAccuWeatherData, setData]);

  return null;
};
